import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import lodash from "lodash";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
const reducerModules: any = import.meta.glob("./modules/*.*", {
  eager: true,
});
const reducerObject: any = {};
Object.keys(reducerModules).forEach(key => {
  const fileName = key.replace(/(.*\/)*([^.]+).*/gi, "$2");
  reducerObject[fileName + "Reducer"] = reducerModules[key].default;
});
const rootReducer = combineReducers({
  ...reducerObject,
});
const persistConfig = {
  key: "root",
  storage,
  /* whitelist: ["homeReducer"],
  blacklist: ["locationReducer"], */
  /* blacklist: Object.keys(lodash.omit(reducerObject, ["homeReducer"])), */
  blacklist: Object.keys(reducerObject),
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
const persistor = persistStore(store);
export { store, persistor };
